export default {
  IFRAME_ID: 'membership-iframe',
  SUCCESS_QUERY: 'tokenisationSuccess',
  SUCCESS_MESSAGE: 'tokenisation-successful'
}
